export default __webpack_public_path__ + "static/DW-Apple-Lime-7c67872900f52401f24e6046ec2b4207.svg";